<template>
  <div class="member-body">
    <div class="member-content">
      <div class="member-products-body">
        <div class="products-item" v-for="(item,index) in productsArr" :key="index" :class="{'products-item-selected':selectedProductIndex == index}" @click="changeSelectedPriduct(index)">
          <div class="item-content">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="price">
              ¥<label>{{ item.sell_price }}</label>
            </div>
            <div class="show-price">
              ¥<label>{{ item.show_price }}</label>
            </div>
          </div>
          <div class="unit-price">
            {{ item.unit_price }}
          </div>
          <div class="label" v-if="item.label_id != 0">
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="rights-body">
        <div class="rights-title">会员尊享权益</div>
        <div class="rights-option">
          <div class="rights-item" v-for="(item,index) in memberOptions" :key="index">
            <div class="icon">
              <img :src="item.icon" alt="" />
            </div>
            <div class="title">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="rights-body">
        <div class="rights-title">会员尊享权益对比</div>
        <div class="contrast-body" v-if="powersMap != null">
          <div class="contrast-title">
            <div class="name">
              权益
            </div>
            <div class="icon">
              <img src="@/assets/ic_vip.png" alt="" />
            </div>
            <div class="contrast">
              普通用户
            </div>
          </div>
          <div class="contrast-item">
            <div class="contrast-item-name">
              {{ powersMap.max_disk.name }}
            </div>
            <div class="contrast-item-vip">
              <template v-if="convertVipPower(powersMap.max_disk.vip_1.show_value, powersMap.max_disk.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_disk.vip_1.show_value, powersMap.max_disk.vip_1.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.max_disk.vip_0.show_value, powersMap.max_disk.vip_0.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_disk.vip_0.show_value, powersMap.max_disk.vip_0.value) }}
              </template>
            </div>
          </div>
          <div class="contrast-item contrast-item-true">
            <div class="contrast-item-name">
              {{ powersMap.code_limit_days.name }}
            </div>
            <div class="contrast-item-vip contrast-item-vip-true">
              <template v-if="convertVipPower(powersMap.code_limit_days.vip_1.show_value, powersMap.code_limit_days.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.code_limit_days.vip_0.show_value, powersMap.code_limit_days.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.code_limit_days.vip_1.show_value, powersMap.code_limit_days.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.code_limit_days.vip_0.show_value, powersMap.code_limit_days.vip_0.value) }}
              </template>
            </div>
          </div>

          <div class="contrast-item">
            <div class="contrast-item-name">
              {{ powersMap.max_task_upload.name }}
            </div>
            <div class="contrast-item-vip">
              <template v-if="convertVipPower(powersMap.max_task_upload.vip_1.show_value, powersMap.max_task_upload.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_task_upload.vip_0.show_value, powersMap.max_task_upload.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.max_task_upload.vip_1.show_value, powersMap.max_task_upload.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_task_upload.vip_0.show_value, powersMap.max_task_upload.vip_0.value) }}
              </template>
            </div>
          </div>
          <div class="contrast-item contrast-item-true">
            <div class="contrast-item-name">
              {{ powersMap.bool_unzip.name }}
            </div>
            <div class="contrast-item-vip contrast-item-vip-true">
              <template v-if="convertVipPower(powersMap.bool_unzip.vip_1.show_value, powersMap.bool_unzip.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.bool_unzip.vip_0.show_value, powersMap.bool_unzip.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.bool_unzip.vip_1.show_value, powersMap.bool_unzip.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.bool_unzip.vip_0.show_value, powersMap.bool_unzip.vip_0.value) }}
              </template>
            </div>
          </div>

          <div class="contrast-item">
            <div class="contrast-item-name">
              {{ powersMap.max_download_speed.name }}
            </div>
            <div class="contrast-item-vip">
              <template v-if="convertVipPower(powersMap.max_download_speed.vip_1.show_value, powersMap.max_download_speed.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_download_speed.vip_0.show_value, powersMap.max_download_speed.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.max_download_speed.vip_1.show_value, powersMap.max_download_speed.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_download_speed.vip_0.show_value, powersMap.max_download_speed.vip_0.value) }}
              </template>
            </div>
          </div>
          <div class="contrast-item contrast-item-true">
            <div class="contrast-item-name">
              {{ powersMap.bool_play_online.name }}
            </div>
            <div class="contrast-item-vip contrast-item-vip-true">
              <template v-if="convertVipPower(powersMap.bool_play_online.vip_1.show_value, powersMap.bool_play_online.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.bool_play_online.vip_0.show_value, powersMap.bool_play_online.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.bool_play_online.vip_1.show_value, powersMap.bool_play_online.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.bool_play_online.vip_0.show_value, powersMap.bool_play_online.vip_0.value) }}
              </template>
            </div>
          </div>

          <div class="contrast-item">
            <div class="contrast-item-name">
              {{ powersMap.max_upload_size.name }}
            </div>
            <div class="contrast-item-vip">
              <template v-if="convertVipPower(powersMap.max_upload_size.vip_1.show_value, powersMap.max_upload_size.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_upload_size.vip_0.show_value, powersMap.max_upload_size.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.max_upload_size.vip_1.show_value, powersMap.max_upload_size.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_upload_size.vip_0.show_value, powersMap.max_upload_size.vip_0.value) }}
              </template>
            </div>
          </div>
          <div class="contrast-item contrast-item-true">
            <div class="contrast-item-name">
              {{ powersMap.recycle_expired_days.name }}
            </div>
            <div class="contrast-item-vip contrast-item-vip-true">
              <template v-if="convertVipPower(powersMap.recycle_expired_days.vip_1.show_value, powersMap.recycle_expired_days.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.recycle_expired_days.vip_0.show_value, powersMap.recycle_expired_days.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.recycle_expired_days.vip_1.show_value, powersMap.recycle_expired_days.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.recycle_expired_days.vip_0.show_value, powersMap.recycle_expired_days.vip_0.value) }}
              </template>
            </div>
          </div>

          <div class="contrast-item">
            <div class="contrast-item-name">
              {{ powersMap.code_max_files.name }}
            </div>
            <div class="contrast-item-vip">
              <template v-if="convertVipPower(powersMap.code_max_files.vip_1.show_value, powersMap.code_max_files.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.code_max_files.vip_0.show_value, powersMap.code_max_files.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.code_max_files.vip_1.show_value, powersMap.code_max_files.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.code_max_files.vip_0.show_value, powersMap.code_max_files.vip_0.value) }}
              </template>
            </div>
          </div>
          <div class="contrast-item contrast-item-true">
            <div class="contrast-item-name">
              {{ powersMap.max_task_download.name }}
            </div>
            <div class="contrast-item-vip contrast-item-vip-true">
              <template v-if="convertVipPower(powersMap.max_task_download.vip_1.show_value, powersMap.max_task_download.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_task_download.vip_0.show_value, powersMap.max_task_download.vip_0.value) }}
              </template>
            </div>
            <div class="contrast-item-contrast">
              <template v-if="convertVipPower(powersMap.max_task_download.vip_1.show_value, powersMap.max_task_download.vip_1.value) === ''">
                <img src="@/assets/ic_allow.png" alt="" />
              </template>
              <template v-else>
                {{ convertVipPower(powersMap.max_task_download.vip_0.show_value, powersMap.max_task_download.vip_0.value) }}
              </template>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="products-buy-body">
      <div class="agreement-body">
        <div class="check-box">
          <img src="@/assets/check_square_y.png" alt="" />
        </div>
        <div class="agreement">
          请阅读并同意 <a href="">续费协议</a><label>｜</label><a href="">用户协议</a>
        </div>
      </div>
      <div class="btn-body">
        <div class="btn">
          同意协议并支付 <span>¥</span><label>{{ productsArr.length <= 0 ? '0' : productsArr[selectedProductIndex].sell_price }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { products, vipPowers } from '@/utils/api/apis.js'
  import { memberOptions } from '@/utils/member-options.js'
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
      
    },
    data() {
      // 这里存放数据
      return {
        productsArr: [],
        selectedProductIndex: 0,
        powersMap: null,
        memberOptions
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      async getProducts() {
        try{
          var base = await products()
          this.productsArr = base.data;
        }catch(e){
          this.$toast(e)
          this.$errorLog('tab_member/getProducts', e)
        }
      },
      async getVipPowers() {
        try{
          var base = await vipPowers();
          this.powersMap = base.data
        }catch(e){
          this.$toast(e)
          this.$errorLog('tab_member/getVipPowers', e)
        }
      },
      changeSelectedPriduct(index) {
        this.selectedProductIndex = index
      },
      convertVipPower(showValue, value) {
        if (!showValue) {
          return value;
        }

        if (showValue === 'yes') {
          return '';
        }

        if (showValue === 'no' || showValue === '0') {
          return '无';
        }

        return '无限';
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getProducts()
      this.getVipPowers()
    },
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  @font-face {
      font-family: 'squadaone';
      src: url('../../assets/fonts/squadaone-aorm.ttf') format('truetype');
  }
  .member-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    .member-content {
      height: calc(100vh - 300px);
      overflow-y: auto;
      scrollbar-width: none; /* Firefox */

      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
      }
      .member-products-body {
        display: flex;
        flex-wrap: wrap;
        .products-item {
          width: 130px;
          height: 143px;
          border: 2px solid #FFBF81;
          margin: 16px 0px 0 24px;
          border-radius: 18px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 6px 0;
          .item-content {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            justify-content: center;
            flex-direction: column;
            .title {
              font-size: 13px;
              font-weight: bold;
              color: rgba(113, 56, 1, 1);
              margin-bottom: 8px;
            }
            .price {
              font-family: 'squadaone';
              font-weight: bold;
              color: black;
              font-size: 24px;
              margin-bottom: 8px;
              label {
                font-size: 36px;
                font-family: 'squadaone';
              }
            }
            .show-price {
              color: rgba(34, 34, 34, 0.60);
              text-decoration: line-through;
            }
          }
          .unit-price {
            background-color: rgba(255, 206, 160, 0.30);
            width: 118px;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 18px;
            font-size: 11px;
            border-radius: 6px;
            color: rgba(113, 56, 1, 0.90);
          }
          .label {
            position: absolute;
            top: -9px;
            left: -2px;
            font-size: 10px;
            background: linear-gradient( 270deg, #FF177E 0%, #FF7429 100%);
            border-radius: 28px 18px 18px 0px;
            padding: 0 10px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
          }
        }
        .products-item:hover {
          cursor: pointer;
        }
        .products-item-selected {
          background: linear-gradient( 180deg, #FFD8B3 0%, #FFEBD8 35%, #FFF6ED 100%);
          .item-content {
            .title {
              color: rgba(113, 56, 1, 1);
            }
            .price {
              color: rgba(113, 56, 1, 1);
            }
            .show-price {
              color: rgba(113, 56, 1, 0.60);
            }
          }
          .unit-price {
            color: rgba(113, 56, 1, 0.90);
          }
        }
      }
      .rights-body {
        padding: 0 24px;
        .rights-title {
          height: 48px;
          display: flex;
          align-items: center;
          font-size: 22px;
          font-weight: bold;
          text-align: left;
          background: linear-gradient(90deg, #C05E00 1%, #713801 10%, #713801 100%);
          -webkit-background-clip: text; /* 仅对文字裁剪背景 */
          -webkit-text-fill-color: transparent; /* 设置文字颜色透明 */
        }
        .rights-option {
          display: flex;
          flex-wrap: wrap;
          row-gap: 5px;
          column-gap: 10px;
          .rights-item {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background: linear-gradient( 180deg, #FFEDDD 0%, #FFFAF5 88%, #FFFFFF 100%), #FFFAF6;
            border-radius: 16px;
            width: 80px;
            height: 98px;
            .icon {
              width: 52px;
              height: 52px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 52px;
                height: 52px;
              }
            }
            .title {
              margin-top: 6px;
              color: rgba(0, 0, 0, 0.60);
              font-size: 12px;
            }
          }
        }
        .contrast-body {
          .contrast-title {
            display: flex;
            align-items: center;
            width: 360px;
            .name {
              height: 36px;
              background-color: rgba(248, 248, 248, 1);
              display: flex;
              align-items: center;
              justify-content: center;
              width: 120px;
              margin-top: 6px;
              font-weight: bold;
              color: rgba(186, 169, 152, 1);
              font-size: 13px;
            }
            .icon {
              height: 42px;
              background: linear-gradient( 316deg, #FFE2C5 0%, #FFF6ED 100%);
              border-radius: 12px 12px 0px 0px;
              width: 120px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 32px;
              }
            }
            .contrast {
              height: 36px;
              background-color: rgba(248, 248, 248, 1);
              display: flex;
              align-items: center;
              justify-content: center;
              width: 120px;
              margin-top: 6px;
              font-weight: bold;
              color: rgba(102, 102, 102, 1);
              font-size: 13px;
            }
          }
          .contrast-item {
            height: 36px;
            display: flex;
            align-items: center;
            background-color: white;
            font-weight: bold;
            font-size: 13px;
            width: 360px;
            .contrast-item-name {
              width: 120px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .contrast-item-vip {
              width: 120px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: rgba(163, 66, 0, 1);
              background-color: rgba(255, 243, 230, .3);
              height: 100%;
              img {
                width: 32px;
                height: 32px;
              }
            }
            .contrast-item-vip-true {
              background-color: rgba(255, 243, 230, 1);
            }
            .contrast-item-contrast {
              width: 120px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              color: rgba(102, 102, 102, 1);
              img {
                width: 32px;
                height: 32px;
              }
            }
          }
          .contrast-item-true {
            background-color: rgba(248, 248, 248, 1);
          }
        }
      }
    }
    .products-buy-body {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 105px;
      .agreement-body {
        display: flex;
        align-items: center;
        justify-content: center;
        .check-box {
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          img {
            width: 18px;
            height: 18px;
          }
        }
        .check-box:hover {
          cursor: pointer;
        }
        .agreement {
          font-size: 13px;
          color: #999;
          a {
            text-decoration: none;
            color: #666;
          }
        }
      }
      .btn-body {
        width: 300px;
        height: 42px;
        margin-top: 12px;
        background: linear-gradient( 315deg, #864406 0%, #D27000 100%);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: bold;
        font-size: 15px;
        span {
          font-family: 'squadaone';
        }
        label {
          font-size: 24px;
          font-family: 'squadaone';
        }
      }
      .btn-body:hover {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/tab_member.vue